<div class="d-grid gap-2 col-8 mx-auto">
    <div class="col-md-auto">
        <h2 class="modal-title text-center">Don’t Lose Your Farmbox Customizations!</h2>
    </div>
</div>

<div class="row row-cols-1 justify-content-sm-center mt-3">
    <div class="col-12">
        <div class="d-flex align-items-center text-center mb-2">
            <p>
                You haven’t saved your Farmbox customizations. If you continue without saving, your changes will be
                lost. Would you like to save them now?
            </p>
        </div>
    </div>
</div>

<div class="row justify-content-md-center mt-4">
    <div class="col-6 mb-2 mb-sm-0">
        <button type="button" class="btn btn-outline-primary w-100 h-100" (click)="closeModal(true)">
            Don't Save
        </button>
    </div>
    <div class="col-6">
        <button type="button" class="btn btn-primary w-100" (click)="execute()">
            Save
        </button>
    </div>
    <div class="col-12 mt-2 text-center">
        <a href="javascript:void(0)" (click)="closeModal()" class="link-primary">Continue Editing</a>
    </div>
</div>